export default "__VITE_ASSET__xq$YAcGD__"